﻿import { IMilestoneTemplate } from "@/interfaces";

const INDEX_NOT_FOUND = -1;

export const deleteMilestone = (
  milestones: IMilestoneTemplate[],
  milestoneToDelete: IMilestoneTemplate
): IMilestoneTemplate[] => {
  const index = milestones.findIndex(({ id }) => id === milestoneToDelete.id);

  if (index === INDEX_NOT_FOUND) {
    const milestonesWithoutReference = JSON.parse(JSON.stringify(milestones));
    return milestonesWithoutReference.map((milestone: IMilestoneTemplate) => {
      if (milestone.childMilestones) {
        milestone.childMilestones = deleteMilestone(
          milestone.childMilestones,
          milestoneToDelete
        );
      }

      return milestone;
    });
  }

  return milestones.filter(({ id }) => id !== milestoneToDelete.id);
};
